var _rect, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBeach1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 360 571"
}, props), /*#__PURE__*/React.createElement("g", {
  mask: "url(#Beach1_svg__mask1_1175_5710)"
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 360,
  height: 571,
  fill: "url(#Beach1_svg__a)",
  rx: 18
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Beach1_svg__b)",
  d: "M0 0h369v603H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#60D8BD",
  d: "M0 380h369v223H0z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "Beach1_svg__c",
  width: 457,
  height: 337,
  x: -29,
  y: 152,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M397.913 152-29 189.681.464 488.447l426.913-37.681z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Beach1_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M-28.787 200.826c34.83-3.075 30.896 7.398 34.854 25.811 3.958 18.414 10.146 29.024 59 16.091s68.778 6.607 73.55 37.626c4.773 31.019 17.954 12.614 25.658 34.247s26.152 8.847 45.875-4.049 20.502 12.389 46.767 5c26.264-7.39 40.514-19.297 49.656 16.915 9.141 36.211 43.411 14.424 64.099 46.067s53.254 27.951 53.254 27.951l4.478 45.415L-.295 489.738z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M370.42 375.996c-20.688-31.642-54.958-9.855-64.099-46.066-9.141-36.212-23.392-24.305-49.656-16.916-26.265 7.389-27.045-17.897-46.767-5s-38.172 25.682-45.875 4.049-20.884-3.228-25.657-34.246-24.696-50.559-73.55-37.626S9.773 242.514 5.815 224.1c-3.958-18.413-.023-28.886-34.854-25.812l.795 8.06c4.034-.694 7.84-1.326 11.304-1.538 4.685.508 8.38 1.853 10.929 5.038 3.103 3.878 4.383 10.549 3.913 20.393-.065 1.365-.144 2.727-.22 4.044-.57 9.802-1.063 18.267 4.114 23.729 2.811 2.965 8.653 6.235 23.38 6.842 4.871.201 32.226-.469 68.98-7.715l3.642-.676c7.93-1.469 12.924-.84 15.265 1.92 2.845 3.353 1.956 10.028.925 17.756-.766 5.748-3.577 22.502-1.093 31.651 1.412 5.199 4.222 9.191 10.578 10.663 41.217 9.547 30.017 42.729 61.76 25.729 7.844-4.201 13.416-8.03 17.294-11.747 5.767-5.528 13.435-7.786 20.303-2.375 5.296 4.172 10.144 5.467 15.719 4.199 5.266-1.198 10.882-4.489 18.656-9.043 1.336-.783 7.91-4.31 11.666-5.252 13.742-3.444 19.651 6.175 23.904 16.762 3.241 12.423 8.152 31.149 28.614 30.104 10.493-.536 16.701.208 21.428 2.569 4.652 2.323 7.864 6.178 12.727 12.013 2.728 3.274 5.729 7.108 9.936 11.367 25.634 25.948 52.793 21.611 59.158 20.942l-.964-9.775s-32.566 3.692-53.254-27.951zM2.637 256.895c-4.682-4.938-4.21-13.05-3.663-22.442.076-1.322.156-2.689.222-4.063.498-10.439-.863-17.291-4.283-21.564a13.1 13.1 0 0 0-4.412-3.568c8.223 1.917 12.854 9.653 11.118 31.806-.974 12.424 2.158 19.803 7.944 23.801-2.96-.889-5.254-2.207-6.926-3.97m111.629 28.107.014-.005-.029.159q.007-.077.015-.154m2.215-12.636c-.536-3.539.819-11.519-2.521-15.037-2.853-3.006-7.922-3.944-16.415-2.372l-3.642.676c-17.566 3.263-32.254 5.99-46.093 6.171 21.033-4.768 44.182-13.329 57.728-12.253 11.924.948 12.638 10.805 10.942 22.815zm140.11 51.479c-15.032 8.807-22.577 13.228-33.073 4.958-5.742-4.523-9.685-4.991-14.247-2.997 5.768-6.151 7.526-8.266 17.69-2.141 14.499 8.739 16.314 4.624 30.671-.43zm109.734 67.822c-4.085-4.349-7.162-8.041-9.876-11.299-9.805-11.767-13.474-16.17-35.17-15.062-7.37.377-12.595-1.881-16.425-5.518 11.261 6.75 30.618-5.388 44.097 7.539 8.561 8.209 23.375 32.45 47.613 42.396-8.939-2.238-20.058-7.221-30.239-18.056"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#90F6DF",
  d: "M132.017 306.547c-16.579-4.504-12.189 3.843-3.732 5.601s8.428-4.325 3.732-5.601M118.946 300.807c-1.671.518-.896 2.868 2.003 1.852s-.479-2.325-2.003-1.852M173.747 338.016c-5.852 2.207-5.752 6.847.512 5.195 6.264-1.651 5.34-7.401-.512-5.195M241.224 322.705c-3.55.206-4.185 2.459 1.637 2.114s1.913-2.319-1.637-2.114M17.934 257.198c-6.607.686-4.905 3.363 3.185 3.325s4.073-4.078-3.185-3.325M40.191 258.913c-4.129 1.476-.825 2.256 2.935.797s-.268-1.751-2.935-.797"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#60D8BD",
  d: "M273.964 357.787c-45.582-20.374-103.001 15.708-144.163-5.929-45.138-23.726-8.628-94.209-95.43-74.409-42.09 9.601-45.255 12.968-56.217-2.753l21.7 216.308L415.33 451.77c-61.098-48.59-55.724-29.023-75.605-59.304-19.29-16.263-39.303-22.852-65.762-34.679"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Beach1_svg__a",
  x1: 180,
  x2: 180,
  y1: 0,
  y2: 571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9F8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C7EEFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Beach1_svg__b",
  x1: 184.5,
  x2: 184.5,
  y1: 0,
  y2: 368.799,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE7C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD598"
})))));
export default SvgBeach1;